export function view_init(selfClass) {

  const $ = jQuery;


  $(document).on('click.dzswtl', '.increment-val,.decrement-val,  .auto-hide--expand-button', handle_mouse);


  function handle_mouse(e) {

    const $t = $(this);

    if (e.type === 'click') {

      if ($t.hasClass('auto-hide--expand-button')) {
        $t.parent().toggleClass('is-expanded');
      }
      if ($t.hasClass('increment-val')) {
        if ($t.parent().find('input[name="quantity"]').length) {
          let _c = $t.parent().find('input[name="quantity"]').eq(0);
          _c.val(Number(_c.val()) + 1);
        }
      }
      if ($t.hasClass('decrement-val')) {
        if ($t.parent().find('input[name="quantity"]').length) {
          let _c = $t.parent().find('input[name="quantity"]').eq(0);
          var tempnr = Number(_c.val()) - 1;

          if (tempnr < 0) {
            tempnr = 0;
          }
          _c.val(tempnr);
        }
      }
    }
  }
}


export function view_reinit(selfClass) {
  selfClass.cthis.find('.dzswtl--item-instance').each(function () {
    const $itemInstance = jQuery(this);


    if ($itemInstance.find('.col-feed-from-product-image').length) {
      if ($itemInstance.find('.col-feed-from-product-image').children().length) {
        $itemInstance.addClass('has-featured-image');
      }
    }


    if ($itemInstance.hasClass('has-featured-image') === false) {
      if ($itemInstance.find('.zoomsounds-mode-just-play-button').length && $itemInstance.find('.zoomsounds-mode-just-waveform').length) {
        $itemInstance.addClass('has-just-play-and-has-just-waveform')
      }
    }

    if (selfClass.cthis.hasClass('auto-hide--has-expandable-button')) {

      if ($itemInstance.children('.auto-hide--expand-button').length === 0) {
        $itemInstance.append('<div class="auto-hide--expand-button"><figure><span>&#x25BC;</span></figure></div>')
      }
    }
  })

  if (selfClass.view_layoutMode === 'list') {
  }


  if (jQuery('.dzs-wtl-submit-changes-btn').length) {
    window.dzswtl_block_changes = true;
    window.dzswtl_collect_args_in_timeout = true;
  }

  window.lazyloading_reinit();
  selfClass.handle_resize();
}


export function view_resizeAssignLayerProperties(selfClass) {
  let layerWidths = [];
  var $ = jQuery;

  selfClass.cthis.addClass('responsive-is-auto-hide-some-cols');

  selfClass.$innerRows.find('.dzswtl--item-instance').eq(0).addClass('first-inner-item');
  selfClass.$innerRows.find('.dzswtl--item-instance').eq(0).find('.table-item--inner  > .table--content--item').each(function () {

    if (!$(this).hasClass('auto-hidden-layer')) {
      $(this).css('order', '');
    }

    let layerWidth = $(this).outerWidth();

    layerWidths.push({
      width: layerWidth,
      autoHidden: $(this).hasClass('auto-hidden-layer'),
      priorityOrder: $(this).attr('data-priority-index'),
    })
  });
  selfClass.cthis.find('.dzswtl--item-instance').each(function () {
    const $itemInstance = $(this);

    if ($itemInstance.hasClass('first-inner-item')) {
      return;
    }

    let isItemResizable = true;
    let layoutItemInstanceIndex = 0;
    $itemInstance.find('.table-item--inner  > .list-col').each(function () {

      const $columnItem = $(this);


      if (layerWidths[layoutItemInstanceIndex]) {

        if (Number(layerWidths[layoutItemInstanceIndex].width) === 0 && (Number($columnItem.get(0).scrollWidth) - Number(layerWidths[layoutItemInstanceIndex].width)) > 5) {
          isItemResizable = false;
        }

        if (isItemResizable) {

          $columnItem.css('max-width', layerWidths[layoutItemInstanceIndex].width + 'px')
          $columnItem.css('min-width', layerWidths[layoutItemInstanceIndex].width + 'px')
        }
        if ($itemInstance.hasClass('table--header')) {
          if (layerWidths[layoutItemInstanceIndex].width < 10) {

            $columnItem.hide();
          }
        }
        if (layerWidths[layoutItemInstanceIndex].autoHidden) {
          if ($itemInstance.hasClass('table--header')) {
            $columnItem.hide();
          } else {
            $columnItem.addClass('auto-hidden-layer');
            $columnItem.css('order', layerWidths[layoutItemInstanceIndex].priorityOrder)
          }
        }

        layoutItemInstanceIndex++;
      }
    })
  })

}

export function view_listResponsiveAutohide(selfClass) {
  var $ = jQuery;
  selfClass.$innerRows.find('.dzswtl--item-instance .table-item--inner  > .table--content--item').css('order', '').removeClass('auto-hidden-layer')
  selfClass.cthis.removeClass('responsive-is-auto-hide-some-cols');

  let nrOfRows = 0;
  let isMoreThanOneRow = false;
  let maxOffsetY = null;
  let priorityItems = [];

  let hiddenRows = 0;

  function calculateNumberOfHiddenRows() {
    priorityItems.forEach(($layerItem) => {
      if (maxOffsetY != null) {
        if ($layerItem.get(0).offsetTop >= maxOffsetY) {
          isMoreThanOneRow = true;
          nrOfRows++;
        }
      }
      if (!isMoreThanOneRow && $layerItem.get(0).offsetTop + $layerItem.get(0).offsetHeight > maxOffsetY) {
        maxOffsetY = $layerItem.get(0).offsetTop + $layerItem.get(0).offsetHeight;
      }
    })
  }

  function sortByPriorityIndex(a, b) {
    return Number(a.attr('data-priority-index')) > Number(b.attr('data-priority-index')) ? -1 : Number(a.attr('data-priority-index')) < Number(b.attr('data-priority-index')) ? 1 : 0;
  }

  /**
   * called if it's not mobile and it's more than one row
   */
  function autohideLayers() {

    selfClass.cthis.addClass('responsive-is-auto-hide-some-cols');

    priorityItems.forEach(($layerItem) => {

      if (hiddenRows < nrOfRows) {
        if ($layerItem.attr('data-priority-allow-hide') === 'on') {
          $layerItem.css('order', Number($layerItem.attr('data-priority-index')) * 10);
          if ($layerItem.get(0).offsetTop >= maxOffsetY) {
            $layerItem.addClass('auto-hidden-layer');
          }
          hiddenRows++;
        }
      }
    })
  }


  /**
   * on phone we should
   */
  if (!selfClass.view_responsiveIsPhone) {


    selfClass.$innerRows.find('.dzswtl--item-instance').eq(0).find('.table-item--inner  > .table--content--item').each(function () {
      var $layerItem = $(this);
      priorityItems.push($layerItem);
    });


    selfClass.$innerRows.find('.table-item--inner  > .table--content--item').removeClass('auto-hidden-layer').css('order', '');

    calculateNumberOfHiddenRows();


    selfClass.$innerRows.find('.auto-hide--expand-button').height(maxOffsetY);

    priorityItems.sort(sortByPriorityIndex);
    if (isMoreThanOneRow) {
      autohideLayers();

      selfClass.cthis.addClass('auto-hide--has-auto-hidden-rows');
      selfClass.cthis.addClass('auto-hide--has-expandable-button'); // todo: will come from option

      let oldNrOfRows = nrOfRows;
      nrOfRows = 0;
      hiddenRows = 0;


      calculateNumberOfHiddenRows(true);

      if (oldNrOfRows < nrOfRows) {
        autohideLayers();
      }

    } else {

      selfClass.cthis.removeClass('auto-hide--has-auto-hidden-rows');
    }
    view_resizeAssignLayerProperties(selfClass);
  }
}
